import React from "react"

const DayLightRain: React.FC<{ styling?: any }> = ({ styling }) => {
  return (
    <svg
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      viewBox="0 0 30 30"
      css={[styling]}
      fill="#fff"
    >
      <path
        d="M1.58,16.89c0,0.87,0.21,1.68,0.64,2.42c0.42,0.75,1,1.35,1.73,1.8c0.73,0.45,1.53,0.69,2.4,0.73
	c0.12,0,0.18-0.06,0.18-0.17v-1.33c0-0.12-0.06-0.19-0.18-0.19c-0.85-0.04-1.58-0.38-2.18-1.02s-0.9-1.38-0.9-2.25
	c0-0.82,0.28-1.54,0.84-2.15s1.26-0.96,2.09-1.06l0.52-0.03c0.12,0,0.19-0.06,0.19-0.18l0.08-0.54c0.11-1.08,0.56-1.98,1.36-2.71
	c0.8-0.73,1.75-1.09,2.85-1.09c1.07,0,2.02,0.36,2.84,1.09c0.82,0.73,1.28,1.63,1.4,2.7l0.07,0.58c0,0.11,0.06,0.17,0.17,0.17h1.62
	c0.88,0,1.65,0.32,2.29,0.96c0.65,0.64,0.97,1.39,0.97,2.26c0,0.86-0.3,1.61-0.9,2.25c-0.6,0.63-1.33,0.97-2.18,1.02
	c-0.12,0-0.18,0.06-0.18,0.19v1.33c0,0.11,0.06,0.17,0.18,0.17c0.87-0.02,1.67-0.26,2.4-0.72s1.31-1.05,1.73-1.8
	s0.63-1.56,0.63-2.43c0-0.74-0.14-1.4-0.41-2c0.78-0.95,1.16-2.05,1.16-3.3c0-0.94-0.23-1.82-0.7-2.62s-1.1-1.44-1.9-1.9
	c-0.8-0.47-1.67-0.7-2.61-0.7c-1.55,0-2.84,0.58-3.87,1.73c-0.82-0.44-1.72-0.66-2.69-0.66c-1.41,0-2.65,0.44-3.74,1.31
	s-1.78,1.99-2.09,3.34c-1.1,0.26-2.01,0.84-2.72,1.73C1.93,14.73,1.58,15.75,1.58,16.89z M7.48,17.77c0,0.38,0.14,0.71,0.42,0.98
	s0.62,0.4,1.01,0.4c0.4,0,0.73-0.13,1-0.4c0.27-0.27,0.4-0.59,0.4-0.98c0-0.24-0.12-0.58-0.35-1c-0.23-0.43-0.45-0.76-0.65-0.99
	c-0.21-0.22-0.35-0.37-0.4-0.42l-0.36,0.4c-0.27,0.29-0.52,0.63-0.74,1.03S7.48,17.52,7.48,17.77z M9.97,4.66
	c0,0.26,0.08,0.46,0.24,0.61l0.65,0.66c0.42,0.31,0.82,0.31,1.21,0c0.16-0.19,0.24-0.41,0.24-0.64c0-0.23-0.08-0.43-0.24-0.59
	l-0.64-0.65c-0.19-0.17-0.39-0.25-0.61-0.25c-0.24,0-0.45,0.08-0.61,0.25C10.05,4.22,9.97,4.42,9.97,4.66z M10.45,21.73
	c0,0.66,0.23,1.21,0.68,1.65s1,0.67,1.65,0.67c0.65,0,1.2-0.23,1.66-0.68c0.46-0.46,0.68-1,0.68-1.64c0-0.54-0.27-1.19-0.81-1.97
	c-0.46-0.61-0.89-1.1-1.28-1.49c-0.08-0.06-0.17-0.13-0.26-0.23l-0.23,0.23c-0.36,0.32-0.78,0.82-1.27,1.47
	C10.73,20.5,10.45,21.16,10.45,21.73z M11.93,15.11c0,0.25,0.1,0.47,0.29,0.65c0.19,0.18,0.42,0.27,0.69,0.27
	c0.26,0,0.48-0.09,0.66-0.27c0.18-0.18,0.27-0.4,0.27-0.65c0-0.41-0.31-0.95-0.93-1.6l-0.24,0.25c-0.18,0.2-0.35,0.43-0.5,0.7
	C12,14.73,11.93,14.94,11.93,15.11z M15.3,9.06c0.66-0.66,1.48-0.99,2.47-0.99c0.98,0,1.8,0.34,2.49,1.03
	c0.68,0.69,1.03,1.52,1.03,2.5c0,0.59-0.17,1.2-0.52,1.84C19.8,12.48,18.64,12,17.3,12h-0.33C16.68,10.84,16.12,9.86,15.3,9.06z
	 M16.9,3.8c0,0.24,0.09,0.44,0.26,0.61c0.17,0.17,0.37,0.25,0.6,0.25s0.43-0.08,0.58-0.25c0.16-0.17,0.23-0.37,0.23-0.61V1.76
	c0-0.24-0.08-0.43-0.23-0.59S18,0.94,17.77,0.94s-0.44,0.08-0.61,0.23S16.9,1.52,16.9,1.76V3.8z M22.42,6.11
	c0,0.24,0.08,0.44,0.25,0.59c0.17,0.16,0.36,0.24,0.56,0.24c0.17,0,0.38-0.08,0.61-0.24l1.43-1.43c0.18-0.18,0.27-0.39,0.27-0.62
	c0-0.24-0.08-0.45-0.25-0.61c-0.17-0.16-0.37-0.24-0.61-0.24c-0.22,0-0.41,0.08-0.58,0.25l-1.43,1.43
	C22.5,5.65,22.42,5.86,22.42,6.11z M23.22,17.89c0,0.25,0.08,0.46,0.23,0.64l0.65,0.58c0.14,0.18,0.34,0.27,0.59,0.27
	c0.24,0,0.44-0.09,0.58-0.27c0.18-0.16,0.27-0.36,0.27-0.58c0-0.22-0.09-0.41-0.27-0.58l-0.61-0.65c-0.18-0.16-0.38-0.24-0.61-0.24
	c-0.24,0-0.44,0.08-0.6,0.24S23.22,17.66,23.22,17.89z M24.67,11.6c0,0.22,0.08,0.42,0.25,0.58c0.17,0.16,0.38,0.24,0.63,0.24h2.02
	c0.24,0,0.44-0.08,0.6-0.24c0.17-0.16,0.25-0.35,0.25-0.59c0-0.24-0.08-0.44-0.25-0.6s-0.37-0.25-0.6-0.25h-2.02
	c-0.24,0-0.44,0.08-0.62,0.25S24.67,11.37,24.67,11.6z"
      />
    </svg>
  )
}

export default DayLightRain
